import { render, staticRenderFns } from "./BillboardCreatePage.vue?vue&type=template&id=05bd85a7&"
import script from "./BillboardCreatePage.vue?vue&type=script&lang=ts&"
export * from "./BillboardCreatePage.vue?vue&type=script&lang=ts&"
import style0 from "./BillboardCreatePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports